import { ADMIN_ROUTES, TAG_ROUTES } from '~/constants/router'
import { lazyRetry } from '~/utils/lazyRetry'

import { adminRoles } from '~/modules/auth/conditions'

const TagList = lazyRetry(() => import('~/pages/Tag/TagList'))
const TagForm = lazyRetry(() => import('~/pages/Tag/TagForm'))
const PantryTag = lazyRetry(() =>
  import('@pantry/features').then((m) => ({ default: m.TagPage })),
)

const TagRouters = [
  {
    path: `${ADMIN_ROUTES.STORE}/tags`,
    component: TagList,
    pantryComponent: PantryTag,
    layout: 'admin',
    exact: true,
    roles: adminRoles,
    routeName: 'Tags List',
  },
  {
    path: `${ADMIN_ROUTES.STORE}${TAG_ROUTES.LIST}`,
    component: TagList,
    pantryComponent: PantryTag,
    layout: 'admin',
    exact: true,
    roles: adminRoles,
    routeName: 'Tags List',
  },
  {
    path: `${ADMIN_ROUTES.STORE}${TAG_ROUTES.EDIT}`,
    component: TagForm,
    layout: 'admin',
    exact: true,
    roles: adminRoles,
    xProps: {
      isEditing: true,
    },
    routeName: 'Tag Edit',
  },
  {
    path: `${ADMIN_ROUTES.STORE}${TAG_ROUTES.CREATE}`,
    component: TagForm,
    layout: 'admin',
    exact: true,
    roles: adminRoles,
    routeName: 'Tag Create',
  },
]

export default TagRouters
